'use client'

import { SelectInput, useConfig, useField } from '@payloadcms/ui';
import * as React from 'react';
import { RobotEndpointPostProcessor } from '../../api/types';

type SelectOption = {
  label: string;
  value: string;
};

export const EndpointPostProcessor: React.FC<{ path: string }> = ({ path }) => {
  const { value, setValue } = useField<string>({ path });
  const [options, setOptions] = React.useState<SelectOption[]>([]);
  const { config } = useConfig();
  const { routes: { api: apiRoute } = {} } = config;

  React.useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await fetch(
          `${apiRoute}/llm/endpoint-post-processors`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            referrer: '',
          }
        );
        if (response.ok) {
          const postProcessors =
            (await response.json()) as RobotEndpointPostProcessor[];
          const options: SelectOption[] = postProcessors.map(
            (postProcessor) => ({
              label: postProcessor.id,
              value: postProcessor.value,
            })
          );
          setOptions(options);
        } else {
          setOptions([{ label: (await response.json()).message, value: '' }]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchOptions();
  }, []);

  return (
    <div className="field-type select">
      <label
        className="field-label"
        htmlFor={`field-${path}`.replace(/\./g, '__')}
      >
        Post processor
      </label>
      <SelectInput
        path={path}
        name={path}
        options={options}
        value={value}
        onChange={(option) => Array.isArray(option) ? null : setValue(option.value)}
      />
    </div>
  );
};
